module.exports = __webpack_public_path__ + "img/world_alt2.8d0bda65.svg";